package pl.decks.personal.theme

internal object SitePalettes {
    val light = SitePalette(
        surface = SiteColors.LighterLight,
        highlight = SiteColors.DarkerLight,
        accents = SitePalette.Accents(
            primary = SiteColors.DarkOrange,
            secondary = SiteColors.DarkBlue,
        ),
        profile = SitePalette.ProfileColors(
            systems = SiteColors.SystemsDimensionDark,
            software = SiteColors.SoftwareDimensionDark,
            platforms = SiteColors.PlatformsDimensionDark,
            analytics = SiteColors.AnalyticsDimensionDark,
            product = SiteColors.ProductDimensionDark,
            culture = SiteColors.CultureDimensionDark,
        ),
        military = SitePalette.Military(
            low = SitePalette.MilitaryBadgeColors(
                badge = SiteColors.MilitaryBadgeDark,
                stroke = SiteColors.MilitaryBadgeDark,
                insignia = SiteColors.InsigniaYellow,
            ),
            mid = SitePalette.MilitaryBadgeColors(
                badge = SiteColors.MilitaryBadgeDark,
                stroke = SiteColors.MilitaryBadgeDark,
                insignia = SiteColors.InsigniaAmber,
            ),
            high = SitePalette.MilitaryBadgeColors(
                badge = SiteColors.MilitaryBadgeDarker,
                stroke = SiteColors.MilitaryBadgeDarker,
                insignia = SiteColors.InsigniaOrange,
            ),
        ),
        battery = SitePalette.Battery(
            empty = SitePalette.BatteryColors(
                stroke = SiteColors.BatteryBodyDark,
                fill = SiteColors.BatteryEmptyDark,
            ),
            low = SitePalette.BatteryColors(
                stroke = SiteColors.BatteryBodyDark,
                fill = SiteColors.BatteryLowDark,
            ),
            mid = SitePalette.BatteryColors(
                stroke = SiteColors.BatteryBodyDark,
                fill = SiteColors.BatteryMidDark,
            ),
            high = SitePalette.BatteryColors(
                stroke = SiteColors.BatteryBodyDark,
                fill = SiteColors.BatteryHighDark,
            ),
            full = SitePalette.BatteryColors(
                stroke = SiteColors.BatteryBodyDark,
                fill = SiteColors.BatteryFullDark,
            )
        )
    )

    val dark = SitePalette(
        surface = SiteColors.DarkerDark,
        highlight = SiteColors.LighterDark,
        accents = SitePalette.Accents(
            primary = SiteColors.LightOrange,
            secondary = SiteColors.LightBlue,
        ),
        profile = SitePalette.ProfileColors(
            systems = SiteColors.SystemsDimensionLight,
            software = SiteColors.SoftwareDimensionLight,
            platforms = SiteColors.PlatformsDimensionLight,
            analytics = SiteColors.AnalyticsDimensionLight,
            product = SiteColors.ProductDimensionLight,
            culture = SiteColors.CultureDimensionLight,
        ),
        military = SitePalette.Military(
            low = SitePalette.MilitaryBadgeColors(
                badge = SiteColors.MilitaryBadgeLight,
                stroke = SiteColors.MilitaryBadgeLight,
                insignia = SiteColors.InsigniaYellow,
            ),
            mid = SitePalette.MilitaryBadgeColors(
                badge = SiteColors.MilitaryBadgeLight,
                stroke = SiteColors.MilitaryBadgeLight,
                insignia = SiteColors.InsigniaAmber,
            ),
            high = SitePalette.MilitaryBadgeColors(
                badge = SiteColors.MilitaryBadgeDark,
                stroke = SiteColors.MilitaryBadgeDark,
                insignia = SiteColors.InsigniaOrange,
            ),
        ),
        battery = SitePalette.Battery(
            empty = SitePalette.BatteryColors(
                stroke = SiteColors.BatteryBodyLight,
                fill = SiteColors.BatteryEmptyLight,
            ),
            low = SitePalette.BatteryColors(
                stroke = SiteColors.BatteryBodyLight,
                fill = SiteColors.BatteryLowLight,
            ),
            mid = SitePalette.BatteryColors(
                stroke = SiteColors.BatteryBodyLight,
                fill = SiteColors.BatteryMidLight,
            ),
            high = SitePalette.BatteryColors(
                stroke = SiteColors.BatteryBodyLight,
                fill = SiteColors.BatteryHighLight,
            ),
            full = SitePalette.BatteryColors(
                stroke = SiteColors.BatteryBodyLight,
                fill = SiteColors.BatteryFullLight,
            )
        )
    )
}
